export default "__VITE_ASSET__CuORSupN__"